module.exports = __webpack_public_path__ + "img/1688@2x.6873ed75.png";